import { jsx as _jsx } from "react/jsx-runtime";
import { Combobox } from '../../../combobox/src';
const TIME_PICKER_WIDTHS = {
    base: '',
    full: 'nucleus-flex-1',
};
export const TimePickerInput = ({ type, label, value, onChange, options, hasError, required, disabled, width, }) => {
    const isTimeZoneInput = type === 'timeZoneName';
    return (_jsx(Combobox, { label: label, noOptionsFoundLabel: '', value: value, onChange: (value) => onChange(value, type), options: options, hasError: hasError, size: width === 'full' || isTimeZoneInput ? 'full' : 'xs', required: required, dropdownFitsContent: isTimeZoneInput, disabled: disabled, className: TIME_PICKER_WIDTHS[width] }));
};
//# sourceMappingURL=time_picker_input.js.map